import { object, string, number } from 'yup';

import i18n from '../../../i18n';
import { sentenceCase } from '../../../utils/utils';

// Allows strings containing alphanumeric characters, -, _ and . between 1 and 15 characters
export const COLLECTION_NAME_FORMAT_VALIDATION = /^[a-zA-Z0-9-_.]{1,50}$/g;

export const schema = (collections, isSolrCloud) =>
  object({
    name: string()
      .required(
        sentenceCase(
          i18n.t('inputRequired', {
            ns: 'validations',
            field: i18n.t('collectionName', { ns: 'fields' }),
          })
        )
      )
      .matches(
        COLLECTION_NAME_FORMAT_VALIDATION,
        i18n.t('collectionNameFormat', { ns: 'validations' })
      )
      .notOneOf(
        collections.map((collection) => collection.name),
        sentenceCase(
          i18n.t('duplicate', {
            ns: 'validations',
            field: i18n.t('collectionName', { ns: 'fields' }),
          })
        )
      ),
    shards: isSolrCloud ? number().required() : string().notRequired(),
    replicationFactor: isSolrCloud
      ? number().required()
      : string().notRequired(),
  });
